import { render, staticRenderFns } from "./TrialList.vue?vue&type=template&id=6b27e49b&"
import script from "./TrialList.vue?vue&type=script&lang=js&"
export * from "./TrialList.vue?vue&type=script&lang=js&"
import style0 from "./TrialList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports